module.exports = __webpack_public_path__ + "img/pump-east-liquid.f0a2b00a.png";